import { render, staticRenderFns } from "./SelectMultiMunicipioListItem.vue?vue&type=template&id=073cdfc9&scoped=true"
import script from "./SelectMultiMunicipioListItem.vue?vue&type=script&lang=js"
export * from "./SelectMultiMunicipioListItem.vue?vue&type=script&lang=js"
import style0 from "./SelectMultiMunicipioListItem.vue?vue&type=style&index=0&id=073cdfc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073cdfc9",
  null
  
)

export default component.exports